import type { components } from "./schema";
import axiosInstance from "./axiosInstance";

export type Gallery = components["schemas"]["Gallery"];

export async function getGallery(): Promise<Gallery[]> {
  const { data } = await axiosInstance.get<unknown>("/gallery");
  return Array.isArray(data) ? (data as Gallery[]) : [];
}

export async function getGalleryItem(id: number): Promise<Gallery | null> {
  const { data } = await axiosInstance.get<unknown>(`/gallery/${id}`);

  if (data && typeof data === "object" && !Array.isArray(data)) {
    return data as Gallery;
  }

  return null;
}

